"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const Yup = __importStar(require("yup"));
const formik_1 = require("formik");
const react_redux_2 = require("react-redux");
const selectors_1 = require("@/store/ducks/components/selectors");
const components_1 = require("@/store/ducks/components");
const ComponentsPrompt_1 = __importDefault(require("../ComponentsPrompt"));
const index_view_1 = __importDefault(require("./index.view"));
const partiallyUpdateComponentsUseCase_1 = require("@/useCases/components/partiallyUpdateComponentsUseCase");
const listComponentsUseCase_1 = require("@/useCases/components/listComponentsUseCase");
function ComponentsTable() {
    const dispatch = (0, react_redux_2.useDispatch)();
    const componentsRows = (0, react_redux_1.useSelector)(selectors_1.componentTableRowsSelector);
    const isPromptVisible = (0, react_redux_1.useSelector)(selectors_1.isSavePromptVisibleSelector);
    const isComponentListLoading = (0, react_redux_1.useSelector)(selectors_1.isComponentListLoadingSelector);
    const initialValues = react_1.default.useMemo(() => ({
        components: componentsRows,
    }), [componentsRows]);
    const validationSchema = Yup.object().shape({
        components: Yup.array().of(Yup.object().shape({
            order: Yup.number().required("Required"),
        })),
    });
    const onShowDeleteAlert = react_1.default.useCallback((component, rowIndex) => {
        dispatch((0, components_1.openDeleteComponentAlert)({
            componentToBeDeleted: component,
            rowIndexToBeDeleted: rowIndex,
        }));
    }, [dispatch, components_1.openDeleteComponentAlert]);
    const onSubmit = react_1.default.useCallback((values) => {
        const editedComponents = values.components.filter((component, i) => {
            if (component.order === initialValues.components[i]?.order &&
                component.id !== initialValues.components[i]?.id) {
                return component;
            }
        });
        (0, partiallyUpdateComponentsUseCase_1.partiallyUpdateComponents)(editedComponents)(dispatch).then(() => {
            (0, listComponentsUseCase_1.listComponents)()(dispatch);
            dispatch((0, components_1.onHideSavePrompt)());
        });
    }, [initialValues, dispatch]);
    const onHandleToggleEdition = react_1.default.useCallback(() => {
        if (!isPromptVisible) {
            dispatch((0, components_1.onShowSavePrompt)());
        }
    }, []);
    const onOpenEditComponentModalForm = react_1.default.useCallback((componentToBeEdited) => {
        dispatch((0, components_1.setComponentToBeEdited)(componentToBeEdited));
        dispatch((0, components_1.openEditComponentModal)());
    }, [components_1.setComponentToBeEdited, components_1.openEditComponentModal]);
    return (react_1.default.createElement(formik_1.Formik, { onSubmit: onSubmit, initialValues: initialValues, enableReinitialize: true, validationSchema: validationSchema }, (props) => {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(index_view_1.default, { onOpenEditComponentModalForm: onOpenEditComponentModalForm, onHandleToggleEdition: onHandleToggleEdition, isLoading: isComponentListLoading, componentRowInputs: props.values, onShowDeleteAlert: onShowDeleteAlert }),
            react_1.default.createElement(ComponentsPrompt_1.default, null)));
    }));
}
exports.default = ComponentsTable;
